@for (skeleton of customSkeletons; track skeleton) {
<skeleton [height]="skeleton[0]" [width]="skeleton[1]" [class]="skeleton[2]" />
}
@for (skeleton of requestedDefaultSkeletons; track skeleton) {
<skeleton />
}
<ng-content select="skeleton" />
